<script setup lang="ts">

import EntityActions from '@components/Entity/EntityActions.vue'
import options from '@modules/contrib/betr/postTemplate/themeLena/options'

import { RecordType } from './types'

import { IViewConfig } from '@/types/serverField.type'

const { records, readonly, config, updateRecords } = defineProps<{
  records: Array<RecordType>
  readonly?: boolean
  config?: IViewConfig
  updateRecords:() => void
}>()
</script>

<template>
  <div v-if="records.length">
    <VTable>
      <thead>
        <tr>
          <th>Название</th>
          <th>Кол-во часов для 1 сотрудника</th>
          <th>Кол-во человек</th>
          <th>Тарифная ставка</th>
          <th>Тип поста</th>
          <th class="mw-100">
            Действия
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(record) in records"
          :key="record.Bundle.Uuid"
          :class="{ 'tr-deleted': record.Bundle.IsDeleted }"
        >
          <td>{{ record.Name }}</td>
          <td>{{ record.Hours }}</td>
          <td>{{ record.CountEmployee }}</td>
          <td>{{ record.Tariff }}</td>
          <td>{{ record.PostTypeText }}</td>
          <td>
            <EntityActions
              :options="options"
              :record-edit-form="config?.RecordEditForm"
              :access="record.Bundle.Access"
              :uuid="record.Bundle.Uuid"
              :title="record.Name"
              :is-deleted="record.Bundle.IsDeleted"
              :reload-data="updateRecords"
            />
          </td>
        </tr>
      </tbody>
    </VTable>
  </div>
  <p v-else-if="readonly">
    Записей нет.
  </p>
</template>
